import ButtonSettings from 'client/components/core/Sidebar/components/Settings/entities/button-settings'
import FieldSettings from 'client/components/core/Sidebar/components/Settings/entities/field-settings'
import ContactUsButtonSettings from 'client/pages/contact-us/settings/ButtonSettings'
import ContactUsSettings from 'client/pages/contact-us/settings/ContactUsSettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { FormSettings } from 'src/editor/shared/entities/form/form-settings'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { ContactUsButtonEntityInterface } from 'src/shared/entities/contact-us-button/contact-us-button-entity.schema'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import createCommonEntitySettings from '../createCommonEntitySettings'
import AttachmentsSettings from './settings/AttachmentsSettings'
import ContactUsFieldSettings from './settings/ContactUsFieldSettings'

function createSettingsForContactUs(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUsSettings
          entity={entity as ContactUsInterface}
          defaultEntity={defaultEntity as ContactUsInterface}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonSettings
          entity={entity as ActionButtonEntityInterface}
          defaultEntity={defaultEntity as ActionButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ContactUsButtonSettings
          entity={entity as ContactUsButtonEntityInterface}
          defaultEntity={defaultEntity as ContactUsButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsFieldSettings
          entity={entity as ContactUsFieldEntityInterface}
          defaultEntity={defaultEntity as ContactUsFieldEntityInterface}
        />
      )
    case EntityTypeEnum.Form:
      return (
        <FormSettings
          entity={entity as FormInterface}
          defaultEntity={defaultEntity as FormInterface}
        />
      )
    case EntityTypeEnum.Field:
      return (
        <FieldSettings
          entity={entity as FieldEntityInterface}
          defaultEntity={defaultEntity as FieldEntityInterface}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <AttachmentsSettings
          entity={entity as AttachmentsInterface}
          defaultEntity={defaultEntity as AttachmentsInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForContactUs
